(() => {
  const injectStyles = () => {
    if (document.getElementById('sb-product-hover-styles')) return;

    const style = document.createElement('style');
    style.id = 'sb-product-hover-styles';
    style.textContent = `
      :root{--sb-moss:#3a452e;--sb-paper:#fff;--sb-warm-white:#fffefd;--sb-product-border:rgba(58,69,46,.16);--sb-product-shadow:rgba(49,52,51,.06)}
      .product-card-wrapper .card,.contains-card--product .card{background:var(--sb-paper)!important;border:1px solid var(--sb-product-border)!important;border-radius:2px!important;box-shadow:0 .6rem 2.2rem var(--sb-product-shadow)!important;overflow:hidden!important;transition:border-color 160ms ease,box-shadow 160ms ease,transform 160ms ease!important}
      .product-card-wrapper:hover .card,.product-card-wrapper:focus-within .card,.contains-card--product:hover .card,.contains-card--product:focus-within .card{border-color:rgba(58,69,46,.34)!important;box-shadow:0 1rem 2.8rem rgba(49,52,51,.08)!important;transform:translateY(-2px)!important}
      .product-card-wrapper .card__inner,.contains-card--product .card__inner{background:#f7f6f3!important}
      .product-card-wrapper .card--standard>.card__content .card__information,.contains-card--product .card--standard>.card__content .card__information{padding-left:1.3rem!important;padding-right:1.3rem!important}
      .product-card-wrapper .card__media,.product-card-wrapper .media,.contains-card--product .card__media,.contains-card--product .media{overflow:hidden!important;border-radius:0!important}
      .product-card-wrapper .card__media img,.contains-card--product .card__media img{transition:opacity 180ms ease,transform 180ms ease!important}
      .product-card-wrapper:hover .card__media img:first-child,.product-card-wrapper:focus-within .card__media img:first-child,.contains-card--product:hover .card__media img:first-child,.contains-card--product:focus-within .card__media img:first-child{transform:scale(1.025)!important}
      .product-card-wrapper .quick-add__submit,.product-card-wrapper .button,.contains-card--product .quick-add__submit,.contains-card--product .button{background:var(--sb-moss)!important;border-color:var(--sb-moss)!important;color:var(--sb-warm-white)!important}
      .product-card-wrapper .quick-add__submit:hover,.product-card-wrapper .button:hover,.contains-card--product .quick-add__submit:hover,.contains-card--product .button:hover{background:transparent!important;color:var(--sb-moss)!important}
      .ifn-product-image-wrap{position:relative!important}
      .ifn-product-image-wrap .ifn-product-image{position:absolute!important;inset:0!important;transition:opacity 180ms ease,transform 180ms ease!important}
      .ifn-product-image--secondary{opacity:0!important}
      .ifn-product-card:hover .ifn-product-image-wrap--has-secondary .ifn-product-image--primary,.ifn-product-card:focus-within .ifn-product-image-wrap--has-secondary .ifn-product-image--primary{opacity:0!important}
      .ifn-product-card:hover .ifn-product-image-wrap--has-secondary .ifn-product-image--secondary,.ifn-product-card:focus-within .ifn-product-image-wrap--has-secondary .ifn-product-image--secondary{opacity:1!important;transform:scale(1.035)!important}
    `;
    document.head.appendChild(style);
  };

  const imageUrl = (image) => image?.currentSrc || image?.getAttribute('src') || '';

  const normalizeImageUrl = (value) => {
    if (!value) return '';

    try {
      const url = new URL(value, window.location.origin);
      url.searchParams.delete('width');
      return `${url.origin}${url.pathname}?v=${url.searchParams.get('v') || ''}`;
    } catch {
      return value.split('&width=')[0].split('?width=')[0];
    }
  };

  const enhanceFormulaCard = async (card) => {
    if (card.dataset.formulaHoverReady === 'true') return;
    card.dataset.formulaHoverReady = 'true';

    const imageWrap = card.querySelector('.ifn-product-image-wrap');
    const primaryImage = imageWrap?.querySelector('.ifn-product-image');
    const productUrl = card.getAttribute('href');

    if (!imageWrap || !primaryImage || !productUrl || imageWrap.querySelector('.ifn-product-image--secondary')) return;

    primaryImage.classList.add('ifn-product-image--primary');

    try {
      const response = await fetch(productUrl, { credentials: 'same-origin' });
      if (!response.ok) return;

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const productImages = Array.from(doc.querySelectorAll('.product__media-item img, .product__media img'));
      const primaryKey = normalizeImageUrl(imageUrl(primaryImage));
      const secondarySource = productImages
        .map((image) => imageUrl(image))
        .find((src) => src && normalizeImageUrl(src) !== primaryKey);

      if (!secondarySource) return;

      const secondaryImage = document.createElement('img');
      secondaryImage.src = secondarySource;
      secondaryImage.alt = primaryImage.alt || '';
      secondaryImage.loading = 'lazy';
      secondaryImage.className = 'ifn-product-image ifn-product-image--secondary';

      imageWrap.appendChild(secondaryImage);
      imageWrap.classList.add('ifn-product-image-wrap--has-secondary');
    } catch {
      card.dataset.formulaHoverReady = 'failed';
    }
  };

  const enhance = () => {
    injectStyles();
    document.querySelectorAll('.ifn-formulas .ifn-product-card').forEach(enhanceFormulaCard);
  };

  document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();
